import React from "react";
import "./BrandWordmark.css";

const BrandWordmark = ({ size = "md", className = "" }) => {
  const classes = ["flwrk-wordmark", `flwrk-wordmark-${size}`, className]
    .filter(Boolean)
    .join(" ");

  return <span className={classes}>FLWRK</span>;
};

export default BrandWordmark;
